import { isBelowTier, membershipTierRank } from "@/utils/memberTier";
import { MEMBER_ACTION_FLAGS } from "./purchase.constants";
import type { CardButtonAction } from "./offer";
import type { MemberPurchaseFlags } from "./purchase.types";

/** 卡片点击和权益复核共用意图转换；确认回调保留已展示的计划模式。 */
export function resolveMemberPurchaseFlags(input: MemberPurchaseFlags, action?: CardButtonAction) {
  if (input.trialDeclaration === true) {
    return { skipUpgrade: true, forceUpgrade: false, subscribePlan: false };
  }
  const defaults = MEMBER_ACTION_FLAGS[action ?? "new"];
  const subscribePlan = input.isConfirmUpgrade || !action ? input.subscribePlan : defaults.subscribePlan;
  return {
    skipUpgrade: Boolean(input.skipUpgrade || defaults.skipUpgrade),
    forceUpgrade: Boolean(input.forceUpgrade || defaults.forceUpgrade),
    subscribePlan: Boolean(subscribePlan)
  };
}

/** 旧入口仅识别在期付费档位向上升级；免费开通不进入退款升级。 */
export function isMemberUpgradePurchase(target: string, current: string): boolean {
  return membershipTierRank(current) > 0 && isBelowTier(current, target);
}
